import { Component, OnInit } from '@angular/core';
import { Form, FormControl, FormGroup, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { RelatorioRecadastramentoService } from "../../../service/relatorio-recadastramento/relatorio.service";
import { DynamicFormConfig } from "../../../commons/formulario-dinamico/types/dynamic-form-config";
import { saveAs } from 'file-saver';
import { RelatoriosSrhService } from "../../../service/relatorios-srh/relatorios-srh.service";
import { HttpParams } from "@angular/common/http";
import { MatriculaUtil } from "../../../utils/matricula-util";

@Component({
  selector: 'app-certidao-afastamentos-faltas-abonos',
  templateUrl: './certidao-afastamentos-faltas-abonos.component.html',
  styleUrls: ['./certidao-afastamentos-faltas-abonos.component.sass']
})
export class CertidaoAfastamentosFaltasAbonosComponent implements OnInit {

  matricula: number;
  servidor: any = JSON.parse(sessionStorage.getItem("SessionDataUserAuth"));
  private tipoRelatorio: number;

  constructor(private toastrService: ToastrService,
              private relatorioService: RelatorioRecadastramentoService,
              private relatoriosSrhService: RelatoriosSrhService,
              private toasterService: ToastrService) {
    this.relatoriosSrhService.tipoRelatorio$.subscribe(resp => {
      this.tipoRelatorio = resp;
    });
  }

  ngOnInit(): void {
  }

  config: DynamicFormConfig[] = [
    {
      type: 'autoCompleteServidor',
      class: 'col-md-12',
      label: 'Matrícula com dígito',
      initialValue: `${this.servidor.matricula} - ${this.servidor.nome}`,
      disabled: (this.servidor.perfil == 'M') || (this.servidor.perfil == 'S') ? false : true,
      name: ['servidor'],
      placeholder: 'Digite o Nome do Servidor',
      validation: [Validators.required],
    },
    {
      type: 'betweenDate',
      class: '',
      label: 'Período do Relatório',
      disabled: false,
      name: ['dataInicio', 'dataFim'],
      placeholder: 'Selecione uma data',
      validation: [
        Validators.required
      ],
    }
  ];

  public buscarRelatorio(form) {
    let params = new HttpParams()
      .set('certidao', this.tipoRelatorio)
      .set('matricula', MatriculaUtil.extrairMatricula(form))
      .set('dataFim', new Date(form.value.dataFim).toLocaleString().slice(0, 10))
      .set('dataInicio', new Date(form.value.dataInicio).toLocaleString().slice(0, 10))

    this.relatoriosSrhService.getRelatorios(params, "relatorio-certidoes").subscribe( (resp: Blob) => {
      let blobRg: Blob;
      const fileType = resp.type || 'application/octet-stream';

      let fileName = 'relatorio-faltas-abonos';
      const fileExtension = this.getFileExtensionFromMimeType(fileType);

      if (fileExtension) {
        fileName += '.' + fileExtension;
      }

      blobRg = new Blob([resp], { type: fileType });
      this.downloadFile(blobRg, fileName);

    })
  }

  private getFileExtensionFromMimeType(mimeType: string): string | null {
    const extensionMap = {
      'application/pdf': 'pdf',
      'image/jpeg': 'jpeg',
      'image/jpg': 'jpg',
      'image/png': 'png'
      // Adicione outras extensões e tipos MIME conforme necessário
    };

    return extensionMap[mimeType] || null;
  }

  downloadFile(blob: Blob, fileName: string): void {
    saveAs(blob, fileName);
    this.toasterService.success('Arquivo baixado com sucesso');
  }

}
